import { Link } from "react-router-dom";
import { memeItems } from "@/mocks/memes";

export default function HotStrip() {
  const ranked = [...memeItems].sort((a, b) => b.hot - a.hot).slice(0, 6);
  const maxHot = ranked[0]?.hot ?? 1;

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs tracking-[0.2em] text-primary-600">HOT&nbsp;NOW</span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">今日热度排行</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              按站内浏览与保存次数实时排序，看一眼就知道大家今天都在传哪张图。
            </p>
          </div>
          <Link
            to="/rank"
            className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm text-primary-700 transition-colors hover:bg-primary-100"
          >
            查看完整榜单
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2">
          {ranked.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/meme/${item.id}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-lg ${
                    index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="h-16 w-20 shrink-0 overflow-hidden rounded-md bg-background-100">
                  <img
                    src={item.cover}
                    alt={`${item.title} 缩略图`}
                    title={`${item.title} · 131吃瓜`}
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate font-heading text-base text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-2">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-accent-500"
                        style={{ width: `${Math.round((item.hot / maxHot) * 100)}%` }}
                      ></div>
                    </div>
                    <span className="shrink-0 text-xs text-foreground-500">{item.hot}</span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}